export const LoginSceneTranslation = {
  fi: {
    LoginScene: {
      forgotPassword: 'Unohditko salasanasi?',
      login: 'Kirjaudu',
      fillInformation: 'Täytä tiedot ja kirjaudu sisään',
      twoFactorVerification: 'Kaksivaiheinen tunnistautuminen',
      enter2faCode: 'Syötä vahvistuskoodi mobiilisovelluksestasi',
      verificationCode: 'Vahvistuskoodi',
      verify: 'Vahvista',
      invalidTokenLength: 'Vahvistuskoodin tulee olla 6 numeroa',
      back: 'Takaisin',
    },
  },
};
